import { Scale } from 'chart.js';
import { geoPath, geoAzimuthalEqualArea, geoAzimuthalEquidistant, geoGnomonic, geoOrthographic, geoStereographic, geoEqualEarth, geoAlbers, geoAlbersUsa, geoConicConformal, geoConicEqualArea, geoConicEquidistant, geoEquirectangular, geoMercator, geoTransverseMercator, geoNaturalEarth1, } from 'd3-geo';
const lookup = {
    geoAzimuthalEqualArea,
    geoAzimuthalEquidistant,
    geoGnomonic,
    geoOrthographic,
    geoStereographic,
    geoEqualEarth,
    geoAlbers,
    geoAlbersUsa,
    geoConicConformal,
    geoConicEqualArea,
    geoConicEquidistant,
    geoEquirectangular,
    geoMercator,
    geoTransverseMercator,
    geoNaturalEarth1,
};
Object.keys(lookup).forEach((key) => {
    lookup[`${key.charAt(3).toLowerCase()}${key.slice(4)}`] = lookup[key];
});
export class ProjectionScale extends Scale {
    constructor(cfg) {
        super(cfg);
        this.outlineBounds = null;
        this.oldChartBounds = null;
        this.geoPath = geoPath();
    }
    init(options) {
        options.position = 'chartArea';
        super.init(options);
        if (typeof options.projection === 'function') {
            this.projection = options.projection;
        }
        else {
            this.projection = (lookup[options.projection] || lookup.albersUsa)();
        }
        this.geoPath.projection(this.projection);
        this.outlineBounds = null;
        this.oldChartBounds = null;
    }
    computeBounds(outline) {
        const bb = geoPath(this.projection.fitWidth(1000, outline)).bounds(outline);
        const bHeight = Math.ceil(bb[1][1] - bb[0][1]);
        const bWidth = Math.ceil(bb[1][0] - bb[0][0]);
        const t = this.projection.translate();
        this.outlineBounds = {
            width: bWidth,
            height: bHeight,
            aspectRatio: bWidth / bHeight,
            refScale: this.projection.scale(),
            refX: t[0],
            refY: t[1],
        };
    }
    updateBounds() {
        const area = this.chart.chartArea;
        const bb = this.outlineBounds;
        if (!bb) {
            return false;
        }
        const padding = this.options.padding;
        const paddingTop = typeof padding === 'number' ? padding : padding.top;
        const paddingLeft = typeof padding === 'number' ? padding : padding.left;
        const paddingBottom = typeof padding === 'number' ? padding : padding.bottom;
        const paddingRight = typeof padding === 'number' ? padding : padding.right;
        const chartWidth = area.right - area.left - paddingLeft - paddingRight;
        const chartHeight = area.bottom - area.top - paddingTop - paddingBottom;
        const bak = this.oldChartBounds;
        this.oldChartBounds = {
            chartWidth,
            chartHeight,
        };
        const scale = Math.min(chartWidth / bb.width, chartHeight / bb.height);
        const viewWidth = bb.width * scale;
        const viewHeight = bb.height * scale;
        const x = (chartWidth - viewWidth) * 0.5 + area.left + paddingLeft;
        const y = (chartHeight - viewHeight) * 0.5 + area.top + paddingTop;
        const o = this.options;
        this.projection
            .scale(bb.refScale * scale * o.projectionScale)
            .translate([scale * bb.refX + x + o.projectionOffset[0], scale * bb.refY + y + o.projectionOffset[1]]);
        return (!bak || bak.chartWidth !== this.oldChartBounds.chartWidth || bak.chartHeight !== this.oldChartBounds.chartHeight);
    }
}
ProjectionScale.id = 'projection';
ProjectionScale.defaults = {
    projection: 'albersUsa',
    projectionScale: 1,
    projectionOffset: [0, 0],
    padding: 0,
};
ProjectionScale.descriptors = {
    _scriptable: (name) => name !== 'projection',
    _indexable: (name) => name !== 'projectionOffset',
};
//# sourceMappingURL=ProjectionScale.js.map